import { FlexBox, Typography, Button } from '@vp/swan';
import React, { useContext, useEffect } from 'react';
import { CAContext } from './src-contexts-CAContext.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { MiawChatContext } from './src-contexts-MiawChatContext.js';
import EndChatFeedback from './src-components-EndChatPage-EndChatFeedback.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';

const EndChatPage = ({ onCancelEnd, onEndChatFlowComplete }) => {
  const {
    chatState: { chatSession, enableChatbot, endChatInfo },
    setChatState
  } = useContext(CAContext);
  const {
    state: { sessionId, endChatbotSession, endChatData: chatbotEndChatData, endChatLoading: chatbotEndLoading, isChatbotEndError }
  } = useContext(ChatbotContext);
  const {
    state: { conversationId, endMiawChatSession, endChatData: miawEndChatData, endChatLoading: miawEndChatLoading, isMIAWEndChatError }
  } = useContext(MiawChatContext);
  const { sendTrackingEvent } = useCustomTracking();
  const [showFeedbackPage, setShowFeedbackPage] = React.useState(false);
  useEffect(() => {
    setChatState((prevState) => ({
      ...prevState,
      endChatInfo: chatSession === "chatbotSession" ? { sessionType: "chatbot", sessionId } : chatSession === "miawChatSession" ? { sessionType: "miawChat", sessionId: conversationId } : void 0
    }));
  }, []);
  const onCloseChat = () => {
    if (chatSession === "miawChatSession") {
      endMiawChatSession?.();
    } else if (chatSession === "chatbotSession") {
      endChatbotSession?.({ escalate: false });
    }
  };
  useEffect(() => {
    if (miawEndChatData || chatbotEndChatData || isChatbotEndError || isMIAWEndChatError) {
      setChatState((prevState) => ({
        ...prevState,
        chatSession: "endChatSession",
        isPrivacyPolicyAccepted: false
      }));
      setShowFeedbackPage(true);
    }
  }, [miawEndChatData, chatbotEndChatData, isChatbotEndError, isMIAWEndChatError]);
  const onStartNewChat = () => {
    setChatState((prevState) => ({
      ...prevState,
      endChatInfo: void 0
    }));
    onEndChatFlowComplete?.();
  };
  useEffect(() => {
    if (showFeedbackPage && enableChatbot && endChatInfo?.sessionType === "chatbot") {
      sendTrackingEvent("Chatbot Viewed", "Chatbot:Feedback", "endChatFeedbackPromptShown");
    }
  }, [showFeedbackPage, endChatInfo, enableChatbot]);
  if (showFeedbackPage) {
    return /* @__PURE__ */ React.createElement(EndChatFeedback, { onStartNewChat });
  }
  return /* @__PURE__ */ React.createElement(FlexBox, { compactMode: true, flexDirection: "column", alignItems: "center", justifyContent: "center", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "title-section", mb: "7", textAlign: "center" }, "Are you sure you want to end the conversation?"), /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "column", justifyContent: "space-between", gap: "between-actions" }, /* @__PURE__ */ React.createElement(Button, { skin: "primary", onClick: onCloseChat, loading: chatbotEndLoading || miawEndChatLoading }, "Yes, end conversation"), /* @__PURE__ */ React.createElement(Button, { skin: "secondary", onClick: onCancelEnd, disabled: chatbotEndLoading || miawEndChatLoading }, "No, continue chatting")));
};

export { EndChatPage as default };
//# sourceMappingURL=src-components-EndChatPage-EndChatPage.js.map
